import router from "../axios";
import config from "../../config/index"
const { baseUrl } = config;

function getTimeConfig(data) {
  //获取时间配置
  return router({
    url: baseUrl + "timeConfig/v1/get",
    data: data,
    method: "POST",
  });
}
function saveTimeConfig(data) {
  // 保存时间配置
  return router({
    url: baseUrl + "timeConfig/v1/save",
    data: data,
    method: "POST",
  });
}

function updateTimeConfig(data) {
  // 更新时间配置
  return router({
    url: baseUrl + "timeConfig/v1/update",
    data: data,
    method: "POST",
  });
}

function getAllTagType(data) {
  // 获取价签类型
  return router({
    url: baseUrl + "tag/v1/getAllTagType",
    data: data,
    method: "POST",
  });
}


function saveTagtype(data) {
  // 保存价签类型
  return router({
    url: baseUrl + "merchant/tag/type/v1/create",
    data: data,
    method: "POST",
  });
}

function getMerchant(data) {
  // 获取商户列表

  return router({
    url: baseUrl + "customer/v1/getMerchantList",
    data: data,
    method: "POST",
  });
}

function getRuleList(data) {
  // 获取规则列表
  return router({
    url: baseUrl + "rule/v1/getList",
    data: data,
    method: "POST",
  });
}

// 获取左侧菜单列表
function getScenarioSimplifyList(data) {
  return router({
    url: baseUrl + "scenario/v1/getScenarioSimplifyList",
    data: data,
    method: "POST",
  });
}

// 规则创建保存接口
function ruleCreate(data) {
  return router({
    url: baseUrl + "rule/v1/create",
    data: data,
    method: "POST",
  });
}

// 规则编辑保存接口
function ruleUpdate(data) {
  return router({
    url: baseUrl + "rule/v1/update",
    data: data,
    method: "POST",
  });
}


//规则详情接口
function ruleDetail(data) {
  return router({
    url: baseUrl + "rule/v1/get",
    data: data,
    method: "POST",
  });
}

//规则批量删除接口
function batchDelete(data) {
  return router({
    url: baseUrl + "rule/v1/batchDelete",
    data: data,
    method: "POST",
  });
}

// 规则编辑保存接口

// 获取商户API信息
function getMerchantInfo(data) {
  return router({
    url: baseUrl + "merchant/api/v1/info",
  });
}

// 设置多文本规则lineRule
function setLineRule(data) {
  return router({
    url: baseUrl + "rule/v1/updateLinesRule",
    data: data,
    method: "POST",
  });
}

// api参数修改  
function updateApiCallBack(data) {
  return router({
    url: baseUrl + "merchant/api/v1/update",
  });
}
// 获取多文本规则
function getLineRule(data) {
  return router({
    url: baseUrl + "rule/v1/getLinesRule",
    data: data,
    method: "POST",
  });
}

// 获取门店详情
function getStoreDetail(data) {
  return router({
    url: baseUrl + "store/v1/get",
    data: data,
    method: "POST",
  });
}

// 关闭门店模板自动发布
function unAuto(data) {
  return router({
    url: baseUrl + "store/v1/unAutoFast",
    data: data,
    method: "POST",
  });
}

// 开启门店模板自动发布
function onAuto(data) {
  return router({
    url: baseUrl + "store/v1/onAutoFast",
    data: data,
    method: "POST",
  });
}


// system/v1/config
function getSystemConfig(data) {
  return router({
    url: baseUrl + "system/v1/config",
    data: data,
    method: "POST",
  });
}

// system/v1/timezone
function systemTimezoneList(data) {
  return router({
    url: baseUrl + "system/v1/timezone",
    data: data,
    method: "POST",
  });
}

export {
  getTimeConfig,
  saveTimeConfig,
  updateTimeConfig,
  getAllTagType,
  saveTagtype,
  getMerchant,
  getRuleList,
  getScenarioSimplifyList,
  ruleCreate,
  ruleUpdate,
  ruleDetail,
  batchDelete,
  getMerchantInfo,
  updateApiCallBack,
  setLineRule,
  getLineRule,
  getStoreDetail,
  unAuto,
  onAuto,
  getSystemConfig,
  systemTimezoneList,
}